import { isFlashHotelOffer } from 'lib/offer/offerTypes'

interface Params {
  offer: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
}

const HIDEABLE_ADULT_COUNTS = new Set([1, 2])

function getTotalAdults(filters?: App.OfferListFilters): number {
  return filters?.rooms?.reduce((sum, room) => sum + room.adults, 0) ?? 0
}

function isAnytimeSearch(filters?: App.OfferListFilters): boolean {
  return !filters?.checkIn && !filters?.checkOut && !filters?.flexibleNights
}

export function shouldHideSearchTileRoomBreakdown({ offer, filters }: Params): boolean {
  const totalAdults = getTotalAdults(filters)
  const isOneOrTwoAdultsSearch = HIDEABLE_ADULT_COUNTS.has(totalAdults)

  if (!isOneOrTwoAdultsSearch) {
    return false
  }

  if (isAnytimeSearch(filters)) {
    return true
  }

  return isFlashHotelOffer(offer)
}
